import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import { FormFeedback, FormGroup } from 'reactstrap';
import * as Validator from 'validatorjs';
import { bind } from '../Utils/Bind';
import { componentAutoReaction } from '../Utils/MobxTools';
import { IFormField } from '../Utils/PrimitiveFormField';

export interface IPhoneInputProps<T> {
    onChange?(): void;
    readonly field: IFormField<string | number | boolean | string[] | T | T[] | FileList | undefined>;
    readonly value?: string | number | string[] | boolean | undefined;
    readonly validation?: string;
    readonly className?: string;
    readonly disabled?: boolean;
    readonly required?: boolean;
    readonly defaultCountry?: string;
    readonly placeholder?: string;
}

@observer
export class PhoneInput<T> extends React.Component<IPhoneInputProps<T>> {
    public constructor(props: IPhoneInputProps<T>) {
        super(props);

        componentAutoReaction(
            this,
            () => this.validations,
            v => props.field.onMount(v)
        );
    }

    public render() {
        return (
            <span>
                <ReactPhoneInput {...this.formControlProps} />
                {this.props.field.submitted &&
                    this.props.field.errors?.map((e, idx) => (
                        <FormFeedback key={idx} valid={this.validState}>
                            {e}
                        </FormFeedback>
                    ))}
            </span>
        );
    }

    @bind
    private onFieldChange(value: string) {
        this.props.field.onChange(value);
        if (this.props.onChange) this.props.onChange();
    }

    @computed
    private get validations() {
        const rules = new Set<string>(this.props.validation?.split('|'));
        //rules.add('phone');
        if (this.props.required) rules.add('required');

        return Array.from(rules).join('|');
    }

    @computed
    private get formControlProps() {
        const props: any = {
            inputClass: this.props.className ?? '',
            defaultCountry: this.props.defaultCountry,
            disabled: this.props.disabled,
            placeholder: this.props.placeholder,
            onChange: this.onFieldChange,
        };

        if (this.props.value != undefined && this.props.value != null) {
            props.value = this.props.value;
        } else if (this.props.field.value != undefined && this.props.field.value != null) {
            props.value = this.props.field.value;
        } else {
            props.value = '';
        }

        if (this.validState) props.inputClass += ' is-valid';
        if (this.invalidState) props.inputClass += ' is-invalid';

        return props;
    }

    @computed
    private get validState() {
        switch (this.props.field.state) {
            default:
                return undefined;
            case 'danger':
                return false;
            case 'success':
                return true;
        }
    }

    @computed
    private get invalidState() {
        switch (this.props.field.state) {
            default:
                return undefined;
            case 'danger':
                return true;
            case 'success':
                return false;
        }
    }
}
